export const tenantId = '95c228f4-944c-49ba-abcd-a00985e5497c';
export const redirectUri = import.meta.env.VITE_MSAL_REDIRECT_URI;
export const clientId = import.meta.env.VITE_MSAL_CLIENT_ID;
export const authority = `https://login.microsoftonline.com/${tenantId}`;

// Uncomment localhost when development, and comment for deployment
export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  // scopes: ["api://aeec21ea-2bcc-43b1-afb0-4aaad8f8de26/api.access"]
  scopes: ['api://d76b434a-b9ac-4bb1-b417-40d2eb65d624/user_impersonation']
};
